<template>
  <div ref="tncRef" class="tncMain">
    <count-down layout="mobile" class="mobileBlock" />
    <cw-main>
      <div class="steps mobileBlock">
        <a-steps :current="1">
          <a-step :title="$t('shopping-cart-title')" />
          <a-step :title="$t('transaction-preview')" />
          <a-step :title="$t('receipt-title')" />
        </a-steps>
      </div>
      <div class="tips mobileBlock">
        <p v-html="$t('payment-subtitle-1')"></p>
        <p v-html="$t('payment-subtitle-2')"></p>
      </div>
      <a-row type="flex">
        <!-- 第一部分 -->
        <a-col
          :lg="15"
          class="d-flex flex-column justify-content-between"
          :order="isPc ? 0 : 1"
        >
          <div>
            <div class="steps pcBlock">
              <a-steps :current="1">
                <a-step :title="$t('shopping-cart-title')" />
                <a-step :title="$t('transaction-preview')" />
                <a-step :title="$t('receipt-title')" />
              </a-steps>
            </div>
            <div class="tips pcBlock">
              <p v-html="$t('payment-subtitle-1')"></p>
              <p v-html="$t('payment-subtitle-2')"></p>
            </div>
            <div class="table-box" v-if="reserveInfo">
              <table>
                <tbody>
                  <!-- <tr>
                    <th>
                      <span>
                        {{ $t('payment-type-title') }}:
                      </span>
                    </th>
                    <td>
                      <span>{{ order.paymentName }}</span>
                    </td>
                  </tr> -->
                  <!-- <tr>
                    <th>
                      <span>
                        {{ $t('card-no-title') }}:
                      </span>
                    </th>
                    <td>
                      <span>{{ order.maskedCreditCardNumber }}</span>
                    </td>
                  </tr> -->
                  <tr>
                    <th>
                      <span> {{ $t('delivery-method-title') }}: </span>
                    </th>
                    <td>
                      <span>{{ this.$t('shopping-deliver') }}</span>
                    </td>
                  </tr>
                  <!-- <tr v-if="order.address">
                    <th>
                      <span> {{ $t('postal-address-title') }}: </span>
                    </th>
                    <td>
                      <span>
                        {{ getAddress }}
                      </span>
                    </td>
                  </tr> -->
                  <tr>
                    <th>
                      <span> {{ $t('email-address-title') }}: </span>
                    </th>
                    <td>
                      <span>{{ reserveInfo.reserveEmail }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span> {{ $t('name-title') }}: </span>
                    </th>
                    <td>
                      <span> {{ reserveInfo.reserveName }} </span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span> {{ $t('contact-phone-no-title') }}: </span>
                    </th>
                    <td>
                      <span>{{ reserveInfo.reservePhone }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <th>
                      <span> {{ $t('no-of-tickets-title') }}: </span>
                    </th>
                    <td>
                      <span>{{ getTotalQty }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span> {{ $t('ticket-total-price-title') }}: </span>
                    </th>
                    <td>
                      <span>HK${{ reserveInfo.cityline_total_price }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span> {{ $t('handling-fee-title') }}: </span>
                    </th>
                    <td>
                      <span>HK$ {{ getFee }} </span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span> {{ $t('grand-total-title') }}: </span>
                    </th>
                    <td>
                      <span>HK$ {{ reserveInfo.cityline_total_price_with_fee }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <a-row>
              <a-checkbox
                class="tnc-checkbox"
                @change="handleChange"
              ></a-checkbox>
              <span
                class="tnc-checkbox-text"
                ref="tcRef"
                v-html="$t('tnc')"
              ></span>
              <div class="tcErrorText" v-if="!checked && isClickSubmit">
                {{ $t('accept-terms-title') }}
              </div>
            </a-row>
            <a-row class="btn-wrap" type="flex">
              <!-- 取消订单 -->
              <a-col class="mt-1">
                <a-button size="large" type="link" @click="cancelOrder">
                  {{ $t('cancel-order-title') }}
                </a-button>
              </a-col>
              <!-- 付款详情 -->
              <a-col class="mt-1 edit-btnBox" :lg="{ offset: 1 }">
                <a-button
                  size="large"
                  icon="edit"
                  @click="handleClickOrderInfo"
                >
                  {{ $t('payment-details-title') }}
                </a-button>
              </a-col>
              <!-- 购买 -->
              <a-col class="mt-1" :span="6" :offset="1">
                <a-button class="theme-btn" size="large" @click="submit">
                  {{ $t('app-btn-confirm') }}
                </a-button>
              </a-col>
            </a-row>
          </div>
          <div class="otherPayment-info">
            <p v-html="$t('payment-subtitle-3')"></p>
            <p v-html="$t('payment-subtitle-4')"></p>
          </div>
        </a-col>
        <!-- 第二部分 -->
        <a-col
          :lg="{ span: 8, offset: 1 }"
          :span="24"
          class="shopping-right"
          :order="isPc ? 1 : 0"
        >
          <h4 class="performance-title">
            {{ isPc ? $t('performance-title') : $t('ticket-detail-title') }}
          </h4>
          <div class="ticket" v-if="reserveInfo">
            <ticket-card
              :eventInfo="eventInfo"
              :eventImg="getMelcoI18nLabel(eventConfig, 'coverUrl')"
              :seats="reserveInfo.body.seats"
              :dateLabel="dateLabel"
              :info="reserveInfo"
            />
            <div
              class="noticeContent"
              v-html="getMelcoI18nLabel(eventConfig, 'termsAndConditions')"
            ></div>
            <hr/>
          </div>
          <count-down class="pcBlock" />
        </a-col>
      </a-row>
    </cw-main>
    <payForm v-if="paymentInfo" :payment="paymentInfo"></payForm>
    <div class="fixedBtnWrap mobileBlock" data-display="flex">
      <!-- 取消订单 -->
      <a-button size="large" type="link" @click="cancelOrder">
        {{ $t('cancel-order-title') }}
      </a-button>
      <a-button class="theme-btn" size="large" @click="submit">
        {{ $t('app-btn-confirm') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import cwMain from '@/components/container/cw-main'
import ticketCard from '@/components/ticketCard.vue'
import countDown from '@/components/countDown'
import payForm from '@/components/payForm'
import { melcoPaymentApi } from '@/api/melco.js'
import NP from 'number-precision'
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
let tcWindow = null
export default {
  components: {
    cwMain,
    ticketCard,
    countDown,
    payForm
  },
  data () {
    return {
      isPc: window.innerWidth > 991,
      orderList: [],
      checked: false,
      paymentInfo: null,
      termsOfUseUrl: this.$cwLink + '/TermsOfUse.html?lang=' + this.$i18n.locale,
      isClickSubmit: false,
      showTcLink: null
    }
  },
  computed: {
    ...mapState(['eventInfo', 'eventConfig', 'reserveInfo', 'eventDates']),
    ...mapGetters(['getMelcoI18nLabel']),
    dateLabel () {
      return this.eventDates.find(item => item.id === this.reserveInfo.session_id)?.label || ''
    },
    getFee () {
      if (Object.keys(this.reserveInfo).length === 0) {
        return 0
      }
      const feeArr = NP.minus(Number(this.reserveInfo.cityline_total_price_with_fee), (this.reserveInfo.cityline_total_price)).toFixed(2).split('.')
      return feeArr[0].toLocaleString('en_US') + '.' + feeArr[1]
    },
    getTotalQty () {
      if (Object.keys(this.reserveInfo).length === 0) {
        return 0
      }
      return this.reserveInfo.citylinePrices.reduce((total, item) => {
        return total + item.qty
      }, 0)
    }
  },
  created () {
    this.initMelcoEvent(this.reserveInfo.eventId)
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.tcRef) {
        this.$refs.tcRef.addEventListener('click', this.showTC)
      }
    })
  },
  beforeDestroy () {
    // 清除事件绑定，防止内存泄漏
    if (this.$refs.tcRef) {
      this.$refs.tcRef.removeEventListener('click', this.showTC)
    }
  },
  methods: {
    ...mapMutations(['cancelReserve']),
    ...mapActions(['initMelcoEvent']),
    showTC (event) {
      if (event.target.tagName === 'A') {
        event.preventDefault()
        const fnName = event.target.getAttribute('data-fn')
        this[fnName] && this[fnName]()
      }
    },
    showTermsConditions () {
      const tcLink = this.$cwLink + '/ReleaseNotes.html#termsconditions'
      if (tcWindow) {
        if (this.showTcLink === tcLink) {
          tcWindow.focus()
        } else {
          tcWindow.close()
        }
      }
      this.showTcLink = tcLink
      tcWindow = window.open(
        tcLink,
        '_blank',
        'width=800,height=600,top=100,left=100,scrollbars=no,toolbar=no,location=no,status=no,menubar=no'
      )
    },
    showTermsOfUse () {
      const ppLink = this.$cwLink + '/ReleaseNotes.html#privacypolicy'
      if (tcWindow) {
        if (this.showTcLink === ppLink) {
          tcWindow.focus()
        } else {
          tcWindow.close()
        }
      }
      this.showTcLink = ppLink
      tcWindow = window.open(
        ppLink,
        '_blank',
        'width=800,height=600,top=100,left=100,scrollbars=no,toolbar=no,location=no,status=no,menubar=no'
      )
    },
    handleChange (e) {
      this.checked = e.target.checked
    },
    async submit () {
      this.isClickSubmit = true
      if (!this.checked) {
        document.querySelector('.tnc-checkbox').scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }

      // 如果reserveInfo已经失效，就不让点击了
      if (!this.reserveInfo) {
        window.location.href = this.$cwLink + '?lang=' + this.$i18n.locale
        return
      }

      /* const lang = this.$i18n.locale === 'zh_HK' ? 'zh_TW' : this.$i18n.locale
      const paymentBody = {
        order_group_id: this.reserveInfo.order_group_id,
        payType: '',
        totalCharge: Number(this.reserveInfo.total_gross_price),
        currency: 'MOP',
        merData: '',
        desc: 'melco payment test',
        lang
      }
      console.log(paymentBody, melcoPaymentApi)
      const paymentResult = await melcoPaymentApi(paymentBody)
      console.log('paymentResult', paymentResult)
      this.paymentInfo = paymentResult */
      console.log(this.reserveInfo)
      const lang = this.$i18n.locale === 'zh_HK' ? 'zh_TW' : this.$i18n.locale
      const paymentBody = {
        reference: this.reserveInfo.reference,
        payType: '',
        currency: 'HKD',
        merData: '',
        desc: 'melco payment test',
        lang
      }
      console.log(paymentBody, melcoPaymentApi)
      const paymentResult = await melcoPaymentApi(paymentBody)
      console.log('paymentResult', paymentResult)
      this.paymentInfo = paymentResult
    },
    // 取消订单
    async cancelOrder () {
      await this.cancelReserve()
      window.location.href = this.$cwLink + '?lang=' + this.$i18n.locale
    },
    handleClickOrderInfo () {
      this.$router.push({
        name: 'ShoppingBasket'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tncMain {
  @media (max-width: 991px) {
    padding-bottom: 100px;
    @include background_color('white-background');
  }
}
::v-deep svg {
  vertical-align: baseline;
}
::v-deep .ant-steps-item-process .ant-steps-item-icon {
  background-color: #5577ff;
  border-color: #5577ff;
  font-weight: 700;
  font-size: 1.125rem;
  color: #fff;
}

::v-deep .ant-steps-item-wait .ant-steps-item-icon {
  background-color: #cdd2fd;
  border-color: #cdd2fd;
  font-weight: 400;
  > .ant-steps-icon {
    color: #fff;
  }
}

::v-deep .steps {
  width: 80%;
  margin: 0 auto;
  @media (max-width: 991px) {
    width: 100%;
  }
  .ant-steps {
    display: flex !important;
  }
  .ant-steps-item {
    flex: 1;
    margin: 0 !important;
    padding: 0 !important;
    .ant-steps-item-container {
      position: relative;
      margin-bottom: 40px;
      text-align: center;
      &::before {
        content: '';
        position: absolute;
        width: 50%;
        height: 0;
        top: 15px;
        left: 0;
        right: 0;
        border-bottom: 1px dashed #cdd2fd;
        z-index: 1;
      }
      &::after {
        content: '';
        position: absolute;
        width: 50%;
        height: 0;
        top: 15px;
        left: 50%;
        right: 0;
        border-bottom: 1px dashed #cdd2fd;
        z-index: 1;
      }
    }
    &:first-of-type .ant-steps-item-container::before {
      display: none;
    }
    &:last-of-type .ant-steps-item-container::after {
      display: none;
    }

    .ant-steps-item-tail {
      display: none !important;
    }
    .ant-steps-item-icon {
      float: none;
      margin: 0 !important;
      padding: 0 !important;
      position: relative;
      z-index: 2;
    }
    .ant-steps-item-content {
      position: absolute;
      top: calc(100% + 5px);
      left: 50%;
      transform: translateX(-50%);
    }
    .ant-steps-item-title {
      margin: 0 !important;
      font-size: 1rem;
      @media( max-width: 991px) {
        font-size: 0.75rem;
      }
      &::after {
        display: none;
      }
    }
  }
}

.tips {
  margin-top: 10px;
}

.table-box {
  display: flex;
  flex-wrap: wrap;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    &:last-of-type td {
      text-align: right;
    }
    tr {
      height: 2.5rem;
    }
    th,
    td {
      word-break: break-word;
      vertical-align: top;
      font-size: 1rem;
      @media (max-width: 991px) {
        font-size: 0.875rem;
      }
    }
    th {
      font-weight: bold;
      @include font_color('black15-font_color');
      width: 40%;
    }
    td {
      padding-left: 1rem;
      @include font_color('black27-font_color');
      font-weight: 400;
    }
  }
  @media (min-width: 992px) {
    table {
      width: 50%;
      &:first-of-type {
        border-right: 1px solid rgba(228, 228, 228, 0.6);
        td {
          padding-right: 15px;
        }
      }
      &:last-of-type th {
        padding-left: 15px;
      }
    }
  }
  @media (max-width: 991px) {
    table:first-of-type {
      border-bottom: 1px solid rgba(228, 228, 228, 0.6);
      margin-bottom: 10px;
    }
  }
}

.tnc-checkbox {
  margin-right: 5px;
  ::v-deep .ant-checkbox-inner {
    border-color: #6979f8;
  }
}
.tnc-checkbox-text {
  font-size: 1rem;
  color: font_color('black-font_color');
  @media (max-width: 991px) {
    font-size: 0.75rem;
  }
}
.tcErrorText {
  color: #eb5757;
  font-size: 1rem;
  @media (max-width: 991px) {
    font-size: 0.75rem;
  }
}

.btn-wrap {
  margin: 16px 0;
  justify-content: flex-end;
  .ant-btn {
    width: 100%;
  }
  .edit-btnBox {
    .ant-btn {
      color: #5577ff;
      border-color: #5577ff;
    }
  }
  @media (max-width: 991px) {
    justify-content: center;
    .ant-col {
      display: none;
    }
    .edit-btnBox {
      display: block;
    }
  }
}

.shopping-right {
  @include background_color('white-background');
  @media (max-width: 991px) {
    border-bottom: 1px solid rgba(228, 228, 228, 0.6);
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
  .performance-title {
    margin-top: 10px;
    margin-bottom: 5px;
    padding: 15px;
    color: #465aba;
    font-weight: 700;
    font-size: 1.3125rem;
    @media (max-width: 991px) {
      padding: 15px 0;
      font-size: 0.875rem;
      padding: 0;
      color: #465aba;
      font-weight: bold;
    }
  }

  .ticket {
    padding: 0 15px;
    overflow: auto;
    overflow-x: hidden;
    max-height: 59.0625rem;
    @media (max-width: 991px) {
      max-height: none;
      padding: 0;
    }
    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
      border-radius: 15px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 15px;
      background: rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }
    .ticketCard {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
    .ticket-body {
      padding: 0 15px;
      .ticket-desc-title {
        margin: 20px 0 0;
        font-size: 1rem;
        color: font_color('black27-font_color');
      }
    }

    .noticeContent {
      margin: 15px 0;
      @media (max-width: 991px) {
        padding: 15px;
      }
    }
  }
}

.fixedBtnWrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin: 0;
  padding: 15px;
  @include background_color('white-background');
  box-shadow: 0px -4px 4px rgba(228, 228, 228, 0.6);
  z-index: 900;
  .ant-btn {
    flex: 1 1 50%;
    & + .ant-btn {
      margin-left: 15px;
    }
  }
}

[data-theme='black'] .fixedBtnWrap{
  box-shadow: 0px -4px 4px rgba(27, 27, 27, 0.4);
}

.otherPayment-info {
  font-size: 1rem;
  @media (max-width: 991px) {
    font-size: 0.875rem;
  }
}
</style>
